import classNames from "classnames";
import { useSelector } from "react-redux";
import SekeletonLoader from "shared/loaders/skeleton";
import styles from "./styles.module.scss";

interface StatsCardProps {
  title1: string;
  title2: string;
  value: string;
  loading?: boolean;
  Icon: any;
  onClick?: () => void;
}

const StatsCard = ({
  title1,
  title2,
  value,
  loading,
  Icon,
  onClick,
}: StatsCardProps) => {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  return (
    <div
      className={classNames(
        styles.statContainer,
        theme === "light" && styles.lightThemeIcon,
        onClick && styles.pointer
      )}
      onClick={onClick}
    >
      <div className={classNames("flex items-center gap-4")}>
        <div className={classNames(styles.iconContainer)}>
          <Icon />
        </div>
        <label>
          {title1}
          <br />
          {title2}
        </label>
      </div>

      {loading ? (
        <SekeletonLoader className={classNames(styles.loader)} />
      ) : (
        <span>{value}</span>
      )}
    </div>
  );
};

export default StatsCard;
